//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'PdReviews',
  props: {
    productDetails: { type: Object, required: true },
    baseSku: { type: String, required: true },
    useGenericReviews: { type: Boolean, required: true }
  },
  data () {
    return {
      page: 1,
      failedToLoad: false,
      filterCountry: true
    }
  },
  computed: {
    ...mapGetters({
      getProductSummary: 'review/productSummary',
      getProductReviews: 'review/productReviews',
      getProductReviewPages: 'review/productReviewPages',
      getProductReviewPagesLoaded: 'review/productReviewPagesLoaded',
      summary: 'review/summary',
      getReviews: 'review/reviews',
      reviewPages: 'review/reviewPages',
      reviewPagesLoaded: 'review/reviewPagesLoaded',
      getPageNumbers: 'review/pageNumbers'
    }),
    reviewSummary () {
      return this.useGenericReviews ? this.summary : this.getProductSummary(this.baseSku)
    },
    reviews () {
      return this.useGenericReviews ? this.getReviews(this.page) : this.getProductReviews(this.baseSku, this.page)
    },
    pages () {
      return this.useGenericReviews ? this.reviewPages : this.getProductReviewPages(this.baseSku)
    },
    pagesLoaded () {
      return this.useGenericReviews ? this.reviewPagesLoaded : this.getProductReviewPagesLoaded(this.baseSku)
    },
    pageNumbers () {
      return this.getPageNumbers(this.page, this.pages, this.neighbours)
    }
  },
  methods: {
    async loadPage (pageNumber) {
      if (pageNumber === '...') return
      else if (pageNumber === '<') pageNumber = this.page - 1
      else if (pageNumber === '>') pageNumber = this.page + 1
      if (this.page === pageNumber || pageNumber <= 0 || pageNumber > this.pages) return

      if (!this.pagesLoaded.includes(pageNumber)) {
        await this.$store.dispatch('review/GET_PRODUCT_REVIEWS', { baseSKU: this.baseSku, page: pageNumber, generic: this.baseSku === 'snipers' })
      }

      this.page = pageNumber
      this.$scrollTo('#reviews')
    },
    handleClick (product) {
      this.$scrollTo('#top')
      this.$emit('click', product)
    }
  }
}
